import { PhoneNumberUtil, PhoneNumberType } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

/** Block premium/toll numbers — allow mobile, landline, VoIP, and similar reachable lines. */
const REJECTED_NUMBER_TYPES = new Set([
  PhoneNumberType.TOLL_FREE,
  PhoneNumberType.PREMIUM_RATE,
  PhoneNumberType.SHARED_COST,
  PhoneNumberType.VOICEMAIL,
  PhoneNumberType.PAGER,
  PhoneNumberType.UAN,
]);

/**
 * Google libphonenumber region check — number must belong to the given ISO region.
 * Accepts mobile, landline, and other standard reachable line types for SMS/voice.
 */
export function isValidNumberForRegion(national, region) {
  const digits = String(national ?? "").replace(/\D/g, "");
  if (!digits || !region) return { valid: false };

  try {
    const parsed = phoneUtil.parseAndKeepRawInput(digits, region);
    if (!phoneUtil.isValidNumberForRegion(parsed, region)) {
      return { valid: false };
    }
    const type = phoneUtil.getNumberType(parsed);
    if (REJECTED_NUMBER_TYPES.has(type)) {
      return { valid: false, type };
    }
    return { valid: true, type, parsed };
  } catch {
    return { valid: false };
  }
}

